import { BaseNotificationsList } from "../../../shared/BaseNotificationList";
import { gymNotificationData, gymSubscriptionQuery, redirectOnClick } from "./utils";
import useCurrentUser from "../../../hooks/useCurrentUser";

const GymFullNotificationList = () => {
  const { user } = useCurrentUser();

  return (
    <>
      <BaseNotificationsList
        type="full"
        notificationPreviewData={gymNotificationData}
        query={gymSubscriptionQuery(user.id!)}
        onRedirect={redirectOnClick}
      />
    </>
  );
};

export default GymFullNotificationList;
